import * as types from './types';


export const fetchingData = (status) => (dispatch) => {
  dispatch({ type: types.FETCHING_DATA, payload: status });
};